module.exports = __webpack_public_path__ + "static/media/next.e107752d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/next.svg
// module id = 909
// module chunks = 1